import styled, { css } from 'styled-components';
import { AudioPlayer } from 'src/components';

export const Panel = styled.div<{ $dark: boolean }>(
  ({ theme, $dark }) => css`
    position: relative;
    display: flex;
    align-items: ${$dark ? 'flex-start' : 'center'};
    justify-content: center;
    box-sizing: border-box;
    height: 100%;
    padding-top: ${$dark ? '22dvh' : 0};
    background-color: ${$dark ? theme.co.secondary10 : theme.co.primary95};
  `,
);

export const Speaker = styled(AudioPlayer)(
  ({ theme }) => css`
    width: ${theme.sz.s48};
    height: ${theme.sz.s48};
  `,
);

export const SilentSpeaker = styled.div<{ $dark: boolean }>(
  ({ theme, $dark }) => css`
    color: ${$dark ? theme.co.secondary40 : theme.co.primary60};
    font-size: ${theme.sz.s32};
  `,
);
